import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet, apiPost } from "../../../API/Api_Url";
import { FaUsers, FaTrashAlt, FaEye } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { DollarSign, MapPin, Calendar } from "lucide-react";
import { toast } from "react-toastify";

function AllPendingJobRequirement({ ProUserdata }) {
    const navigate = useNavigate();
    const [JobRequirements, setJobRequirements] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    const GetAllPendingJobRequirements = async () => {
        try {
            const State = ProUserdata?.State || "";
            const City = ProUserdata?.City || "";
            const skill = ProUserdata?.mainSkill || "";

            setIsUploading(true);
            const response = await apiGet(
                `api/labour/LabourGetAllPendingfJobRequirements?state=${encodeURIComponent(
                    State
                )}&city=${encodeURIComponent(City)}&skill=${encodeURIComponent(skill)}`
            );

            if (response?.data) {
                setJobRequirements(response.data);
            } else {
                setJobRequirements([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setJobRequirements([]);
        } finally {
            setIsUploading(false);
        }
    };

    useEffect(() => {
        if (ProUserdata) {
            GetAllPendingJobRequirements();
        }
    }, [ProUserdata]);

    const getStatusColor = (status) => {
        switch (status) {
            case "Pending":
                return "bg-yellow-100 text-yellow-800 border-yellow-200";
            case "Accepted":
                return "bg-green-100 text-green-800 border-green-200";
            case "Rejected":
                return "bg-red-100 text-red-800 border-red-200";
            default:
                return "bg-gray-100 text-gray-800 border-gray-200";
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    };

    const [IsApplicationLoading, setIsApplicationLoading] = useState(false);

    const LabourApplyForJob = async (id) => {
        try {
            setIsApplicationLoading(true)
            const response = await apiPost(`api/labour/ApplyForJob/${id}`);
            toast.success(response?.message || "Job Apply completed.")
            setIsApplicationLoading(false)
        } catch (error) {
            setIsApplicationLoading(false)
            console.error('Error fetching data:', error);
        } finally {
            setIsApplicationLoading(false)
        }
    };

    return (
        <div>
            {isUploading ? (
                <div className="flex items-center justify-center py-20">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                    <p className="ml-4 text-gray-600">Loading pending requirements...</p>
                </div>
            ) : JobRequirements?.length === 0 ? (
                <div className="text-center py-20">
                    <p className="text-xl text-gray-500">No pending job requirements found.</p>
                    <p className="text-gray-400 mt-2">You don’t have any pending jobs right now.</p>
                </div>
            ) : (
                <div className="grid gap-6 grid-cols-1">
                    {JobRequirements?.map((req) => (
                        <div
                            key={req?._id}
                            className="bg-white rounded-2xl shadow-lg p-6"
                        >
                            <div className="flex justify-between items-start mb-4">
                                <h3 className="text-xl font-bold text-gray-900">
                                    Labour Requirement
                                </h3>
                                <span
                                    className={`px-3 py-1 text-xs font-semibold rounded-full border ${getStatusColor(
                                        req?.Status
                                    )}`}
                                >
                                    {req?.Status}
                                </span>
                            </div>

                            {req?.Skillsrequire?.length > 0 && (
                                <p className="text-sm text-gray-600 mb-3">
                                    <span className="font-medium">Skills Required:</span>{" "}
                                    {req?.Skillsrequire.join(", ")}
                                </p>
                            )}

                            <div className="grid grid-cols-2 gap-4 text-sm mb-4">
                                <div className="flex items-center text-gray-700">
                                    <FaUsers className="h-4 w-4 mr-2 text-green-500" />
                                    <p>
                                        <span className="font-medium">Labours:</span>{" "}
                                        {req?.NumberOfLabours}
                                    </p>
                                </div>
                                <div className="flex items-center text-gray-700">
                                    <Calendar className="h-4 w-4 mr-2 text-orange-500" />
                                    <p>
                                        <span className="font-medium">Duration:</span>{" "}
                                        {req?.DurationInDays} days
                                    </p>
                                </div>
                                <div className="flex items-center text-gray-700">
                                    <DollarSign className="h-4 w-4 mr-2 text-purple-500" />
                                    <p>
                                        <span className="font-medium">Per Day Rate:</span> ₹
                                        {req?.PerDayRate}
                                    </p>
                                </div>
                                <div className="flex items-center text-gray-700">
                                    <DollarSign className="h-4 w-4 mr-2 text-blue-500" />
                                    <p>
                                        <span className="font-medium">Total Budget:</span> ₹
                                        {req?.TotalBudget}
                                    </p>
                                </div>
                            </div>

                            {req?.Notes && (
                                <p className="text-gray-700 text-sm mb-3">
                                    <span className="font-medium">Notes:</span> {req?.Notes}
                                </p>
                            )}

                            {req?.Location && (
                                <div className="flex items-start text-gray-600 mb-4">
                                    <MapPin className="h-4 w-4 mr-2 mt-0.5 text-blue-500" />
                                    <p className="text-sm">
                                        {req?.Location?.Address}, {req?.Location?.City},{" "}
                                        {req?.Location?.State}
                                    </p>
                                </div>
                            )}

                            <div className="mt-4 flex justify-between items-center text-sm text-gray-500">
                                <span className="flex items-center">
                                    <Calendar className="h-4 w-4 mr-1" />
                                    Created: {formatDate(req?.createdAt)}
                                </span>
                                <div className="flex items-center gap-2">

                                    <button
                                        onClick={() => LabourApplyForJob(req?._id)}
                                        className="flex items-center gap-1 px-3 py-1 text-sm bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
                                    >
                                        {IsApplicationLoading ? "Please Wait" : "✅ Apply Now"}
                                    </button>
                                </div>
                            </div>

                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default AllPendingJobRequirement;
